import fetch from 'cross-fetch';

import { getAccessToken } from '../authentication/getAccessToken';
import { buildUrl } from '../url/urlBuilderService';

/**
 * @deprecated The method should not be used. Use httpService class instead.
 */
export const httpGet = (url: string, query: { [key: string]: any } = {}, signal?: AbortSignal): Promise<any> => {
  const fetchParams: RequestInit = { method: 'GET' };
  if (signal) {
    fetchParams.signal = signal;
  }
  const requestUrl = buildUrl(url, query);

  return httpFetch(requestUrl, fetchParams);
};

/**
 * @deprecated The method should not be used. Use httpService class instead.
 */
export const httpPost = (url: string, body: { [key: string]: any } = {}): Promise<any> => {
  const fetchParams: RequestInit = {
    method: 'POST',
    body: JSON.stringify(body),
  };

  return httpFetch(url, fetchParams);
};

/**
 * @deprecated The method should not be used. Use httpService class instead.
 */
export const httpPut = (url: string, body: { [key: string]: any } = {}): Promise<any> => {
  const fetchParams: RequestInit = {
    method: 'PUT',
    body: JSON.stringify(body),
  };

  return httpFetch(url, fetchParams);
};

/**
 * @deprecated The method should not be used. Use httpService class instead.
 */
export const httpDelete = (url: string, body: { [key: string]: any } = {}): Promise<any> => {
  const fetchParams: RequestInit = {
    method: 'DELETE',
    body: JSON.stringify(body),
  };

  return httpFetch(url, fetchParams);
};

const parseResponse = async (response: Response) => {
  return response.json().then(responseJson => {
    return responseJson;
  });
};

const httpFetch = async (url: string, params?: RequestInit) => {
  const accessToken = await getAccessToken();

  const headersWithContentType: HeadersInit = {
    ...params?.headers,
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  };

  try {
    const response: Response = await fetch(url, {
      ...params,
      headers: headersWithContentType,
    });
    if (response.ok) {
      return await parseResponse(response);
    }
    throw await parseResponse(response);
  } catch (error) {
    if (error instanceof Error && error.name === 'AbortError') {
      return;
    }
    console.error('Fetch Error', error);

    throw error;
  }
};
